export { default } from './Logotype';
export * from './Logotype';
export * from './Logotype.Tagline';
